import { render } from "./NotesContent.vue?vue&type=template&id=199ce40a&ts=true"
import script from "./NotesContent.vue?vue&type=script&lang=ts"
export * from "./NotesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__